<template>
  <div class="afm">
    <!-- dugme za otvaranje + izabrani filteri -->
    <div class="afm-bar">
      <button type="button" class="afm-open" @click="modalActive">
        <i class="esei icon-filter-solid" aria-hidden="true"></i>
        Filteri
        <span v-if="chips.length" class="afm-count">{{ chips.length }}</span>
      </button>
      <button v-if="chips.length" type="button" class="afl-clear" @click="disableFilter">Očisti sve</button>
    </div>

    <div v-if="chips.length" class="afl-chips afm-chips">
      <button v-for="chip in chips"
              :key="chip.key"
              type="button"
              class="afl-chip"
              :title="`Ukloni: ${chip.label}`"
              @click="chip.remove()">
        {{ chip.label }}
        <i class="esei icon-close" aria-hidden="true"></i>
      </button>
    </div>

    <div id="modal-ads" class="modal-full-filter">
      <div class="afm-sheet">
        <header class="afm-head">
          <button v-if="!manu" type="button" class="afm-back" @click="backToMenu">
            <i class="esei icon-angle-left" aria-hidden="true"></i> Nazad
          </button>
          <span class="afm-title">{{ headTitle }}</span>
          <button type="button" class="afm-close" aria-label="Zatvori filter" @click="exitFilter">
            <i class="esei icon-close" aria-hidden="true"></i>
          </button>
        </header>

        <div ref="contentRef" class="afm-content">
          <!-- glavni meni: svaki red pokazuje trenutni izbor -->
          <ul v-if="manu" class="afm-menu">
            <li v-for="type in menuRows" :key="type.id">
              <button type="button" class="afm-row" @click="selectManu(type)">
                <span class="afm-row-label">{{ type.name }}</span>
                <span class="afm-row-value" :class="{ empty: !menuValue(type) }">{{ menuValue(type) || 'Sve' }}</span>
                <i class="esei icon-chevron-down afm-row-arrow" aria-hidden="true"></i>
              </button>
            </li>
          </ul>

          <!-- kategorije -->
          <div v-else-if="category">
            <div class="afl-search afm-search">
              <i class="esei icon-magnifying-glass-solid" aria-hidden="true"></i>
              <input v-model="categoryQuery" type="search" class="afl-input" placeholder="Pronađi kategoriju…" aria-label="Pronađi kategoriju" autocomplete="off" />
            </div>

            <ul class="afm-list">
              <li>
                <button type="button" class="afl-item" :class="{ on: !selectedCategory }" @click="allCategory()">
                  <span>Sve kategorije</span>
                </button>
              </li>
              <li v-for="item in visibleCategories" :key="item.id">
                <button type="button" class="afl-item" :class="{ on: selectedCategory?.id === item.id }" @click="selectCategory(item)">
                  <span>{{ item.name }}</span>
                  <small v-if="selectedSubcategory && item.id === selectedSubcategory.category_id">{{ selectedSubcategory.name }}</small>
                </button>
              </li>
              <li v-if="!visibleCategories.length" class="afl-empty">{{ categoryQuery ? `Nema kategorije za „${categoryQuery}“.` : 'Nema kategorija.' }}</li>
            </ul>
          </div>

          <!-- potkategorije izabrane kategorije -->
          <ul v-else-if="selectedCategory && subcategory" class="afm-list">
            <li v-for="item in selectedCategory?.subcategories" :key="item.id">
              <button type="button" class="afl-item" :class="{ on: selectedSubcategory?.id === item.id }" @click="selectSubcategory(item)">
                <span>{{ item.name }}</span>
              </button>
            </li>
          </ul>

          <!-- mesta -->
          <div v-else-if="place">
            <div class="afl-search afm-search">
              <i class="esei icon-magnifying-glass-solid" aria-hidden="true"></i>
              <input v-model="placeName" type="search" class="afl-input" placeholder="Pretraži mesta" aria-label="Pretraži mesta" autocomplete="off" @input="findPlaceByName()" />
            </div>

            <ul class="afm-list">
              <li v-for="item in placesList" :key="item.id">
                <button type="button" class="afl-item" :class="{ on: selectedPlace?.id === item.id }" @click="selectPlaces(item)">
                  <span>{{ item.name }}</span>
                </button>
              </li>
            </ul>

            <div v-if="busy" class="afm-busy"><span class="spinner-border spinner-border-sm" role="status"></span></div>
          </div>

          <!-- kupujem / prodajem -->
          <ul v-else-if="buying" class="afm-list afm-opt">
            <li>
              <button type="button" class="afl-item" :class="{ on: !selectedBuying }" @click="selectBuying(null)"><span>Sve</span></button>
            </li>
            <li v-for="buy in optionBuying" :key="buy">
              <button type="button" class="afl-item" :class="{ on: selectedBuying === buy }" @click="selectBuying(buy)"><span>{{ buy }}</span></button>
            </li>
          </ul>

          <!-- cena / dogovor -->
          <ul v-else-if="price" class="afm-list afm-opt">
            <li>
              <button type="button" class="afl-item" :class="{ on: !selectedPrice }" @click="selectPrice(null)"><span>Sve</span></button>
            </li>
            <li v-for="item in optionPrice" :key="item">
              <button type="button" class="afl-item" :class="{ on: selectedPrice === item }" @click="selectPrice(item)"><span>{{ item }}</span></button>
            </li>
          </ul>
        </div>

        <footer class="afm-foot">
          <button type="button" class="afm-ghost" @click="disableFilter()">Poništi filtere</button>
          <button type="button" class="afm-primary" @click="exitFilter">Prikaži oglase</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
    places: Array,
    categories: Array 
})
import { useCustomerDistrictStore } from "~/stores/customer/district";
  
const useDistrictStore = useCustomerDistrictStore();

const route = useRoute();
const router = useRouter();

const { $srbTolat } = useNuxtApp()

import { normalizeText } from '~/composables/useListFilter';

import  FilterDataByRoute  from '~/components/cmsCustomer/advertisement/utils/FilterDataByRoute';



const contentRef = ref(null)

const onContentScroll = () => {
  const listElm = contentRef.value

  if (!listElm || !place.value) return

  if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 10) {
    loadMorePlaces();
  }
}

onMounted(() => {
  contentRef.value?.addEventListener('scroll', onContentScroll)
});

onBeforeUnmount(() => {
  contentRef.value?.removeEventListener('scroll', onContentScroll)
});

const { getFixed, getBuying, getType, getPage, getArrayOfParams, arrToStringWithJoin} = FilterDataByRoute();

const filterType = ref([
{
   id: 0,
   display: true,
   name: 'Kategorije',
   type: 'category'
 },
 {
   id:1,
   display: true,
   name: 'Potkategorija',
   type: 'subcategory'
 },
 {
   id: 2,
   display: true,
   name: 'Mesto',
   type: 'place'
 },
 {
   id: 3,
   display: true,
   name: 'Kupujem/Prodajem',
   type: 'buying'
 },
 {
   id: 4,
   display: true,
   name: 'Cena/Dogovor',
   type: 'price'
 },
])
let placeName = ref(null);

const optionBuying = ref(['kupujem','prodajem'])

const optionPrice = ref(['cena','dogovor'])

 

let arrayOfFilter = ref(getArrayOfParams());

let selectedCategory = ref(null);

let selectedSubcategory = ref(null);

let selectedPlace = ref(null);

let placesList = ref(null);

// vrednosti iz rute: getBuying() je kupujem/prodajem, getType() je (niz) cena/dogovor
const plainValue = (value) => {
  const single = Array.isArray(value) ? value[0] : value

  return single ? single : null
}

let selectedBuying = ref(plainValue(getBuying()));

let selectedPrice = ref(plainValue(getType()));

let category = ref(false)

let subcategory = ref(false)

let buying = ref(false)

let price = ref(false)

let place = ref(false)

let manu = ref(true)

let busy = ref(false)

let page = ref(1)


watchEffect(() => {
    placesList.value = props.places
  })


const loadMorePlaces= async () =>{   
   setTimeout(async () => {
     busy.value = true;
     page.value += 1;
     const { data } = await useDistrictStore.getPlacePaginateCache({
      name: placeName.value,
      place: route.params.place != undefined ? route.params.place.split('-').join(' ') : '',
      page: page.value
     })
 
 placesList.value = data;
 
 
     }, 1000);   

     busy.value = false;
} 
const findPlaceByName = async () => {
 
busy.value = true;
  const { data } = await useDistrictStore.getPlacePaginateCache({
      name: placeName.value,
      place: route.params.place != undefined ? route.params.place.split('-').join(' ') : '',
      page: 1
     })


 placesList.value = data 
 busy.value = false;
}



const categoryByName = () => {

if(route.params.category == undefined)  return  null

return props.categories?.find(x=> $srbTolat.srbTolat(x.name) == route.params.category)

}

const subcategoryByName = () => {

if(route.params.category == undefined)  return  null

let category = categoryByName();

return category?.subcategories?.find(x=> $srbTolat.srbTolat(x.name) == route.params.subcategory)

}

const placeByName = () => {

if(route.params.place == undefined)  return  null

return props.places?.find(x=> $srbTolat.srbTolat(x.name) == route.params.place)


}

selectedCategory.value = categoryByName();

selectedSubcategory.value = subcategoryByName();

selectedPlace.value = placeByName();


// kad se ruta promeni (npr. dugme "nazad" u pregledacu), izbor se uskladjuje sa rutom
watch(() => route.fullPath, () => {
  selectedCategory.value = categoryByName();
  selectedSubcategory.value = subcategoryByName();
  selectedPlace.value = placeByName();
  selectedBuying.value = plainValue(getBuying());
  selectedPrice.value = plainValue(getType());
  arrayOfFilter.value = getArrayOfParams();
})

const addClass = async () => {
      return new Promise((res, rej) =>{
   
        let modalAds = document.getElementById('modal-ads');
        modalAds.classList.add('active')

      })
    }
    
const removeClass = async () => {
      return new Promise((res, rej) =>{

        let modalAds = document.getElementById('modal-ads');
        modalAds.classList.remove('active');
        manu.value = true;

      })
    }
const selectCategory = async (inputCategory) => {
   
 
    
    
    if(selectedCategory.value && selectedCategory.value.name == inputCategory.name){
        selectedSubcategory.value = null;
        selectedCategory.value = null;
        await filtersApi()
        await exitFilter()
      }else{

        selectedCategory.value = inputCategory;
        category.value = false;
        subcategory.value = true;

          

      }
}
const selectSubcategory = async (inputSubcategory) => {
    if(selectedSubcategory.value && selectedSubcategory.value.name == inputSubcategory.name){
        selectedSubcategory.value = null;

        await filtersApi();

      }else{
       selectedSubcategory.value = inputSubcategory;
       filterType.value.find(x=> x.id == 1).display = true;
       category.value = false;
       subcategory.value = false;
       manu.value = true;

       await filtersApi();

      }

      exitFilter()
}
const selectBuying = async (buy) => {

        selectedBuying.value = buy;
        buying.value = false;
        manu.value = true;
        arrayOfFilter.value = arrayOfFilter.value.filter(x=> x != 'kupujem' && x != 'prodajem')

        if(selectedBuying.value != null) arrayOfFilter.value.push(buy)

        await filtersApi();
        await exitFilter()
}
const selectPrice = async (inputPrice) => {
       selectedPrice.value = inputPrice;
       price.value = false;
       manu.value = true;
       arrayOfFilter.value = arrayOfFilter.value.filter(x=> x != 'cena' && x != 'dogovor')

       if(selectedPrice.value  != null) arrayOfFilter.value.push(inputPrice)

       await filtersApi();
       await exitFilter();
}
const selectPlaces = async (inputPlace) => {
    if(selectedPlace.value && selectedPlace.value.name == inputPlace.name){
        selectedPlace.value = null;
       }else{
        selectedPlace.value = inputPlace;
        category.value = false;
        place.value = false;
        manu.value= true;
    
       
       }
       await filtersApi();
       await exitFilter();
}
const selectManu = (type) => {
    switch(type.type){
        case 'category':
          manu.value = false;
          category.value = true;
        break;
        case 'subcategory':
          manu.value = false;
          subcategory.value = true;
        break;
        case 'place':
          manu.value = false;
          place.value = true;
        break;
        case 'buying':
          manu.value = false;
          buying.value = true;
        break;
        case 'price':
          manu.value = false;
          price.value = true;
        break;
}
}
const disableFilter = async () => {
      selectedCategory.value = null;
      selectedSubcategory.value = null;
      selectedPlace.value = null;
      selectedPrice.value = null;
      selectedBuying.value = null;
      category.value = false;
      subcategory.value = false;
      price.value = false;
      place.value = false;
      buying.value = false;
      manu.value = true;
      arrayOfFilter.value = [];
      //this.type_filter.find(x=> x.id == 1).display = false;

      router.push('/oglasi/svi-oglasi/1');

      await exitFilter()
}
const exitFilter = async () => {
      category.value = false;
      subcategory.value = false;
      price.value = false;
      place.value = false;
      buying.value = false;
      manu.value = true;
      await modalInActive()
}
const pageParam = computed(() =>
  arrayOfFilter.value.length > 0
    ? arrToStringWithJoin(arrayOfFilter.value) + "-1"
    : 1
)
const slug = (val) => $srbTolat.srbTolat(val?.name ?? "")

const filtersApi = () => {
  const p = selectedPlace.value
  const c = selectedCategory.value
  const s = selectedSubcategory.value
  
  const base = { page: pageParam.value }

  // 1. Mesto + Kategorija + Potkategorija
  if (p && c && s) {
    return router.push({
      name: "oglasi-mesto-place-category-subcategory-page",
      params: {
        place: slug(p),
        category: slug(c),
        subcategory: slug(s),
        ...base
      }
    })
  }

  // 2. Mesto + Kategorija (bez potkategorije)
  if (p && c && !s) {
    return router.push({
      name: "oglasi-mesto-place-category-page",
      params: {
        place: slug(p),
        category: slug(c),
        ...base
      }
    })
  }

  // 3. Samo Mesto
  if (p && !c) {
    return router.push({
      name: "oglasi-mesto-place-page",
      params: {
        place: slug(p),
        ...base
      }
    })
  }

  // 4. Kategorija + Potkategorija
  if (c && s && !p) {
    return router.push({
      name: "oglasi-category-subcategory-page",
      params: {
        category: slug(c),
        subcategory: slug(s),
        ...base
      }
    })
  }

  // 5. Samo Kategorija
  if (c && !p) {
    return router.push({
      name: "oglasi-category-page",
      params: {
        category: slug(c),
        ...base
      }
    })
  }

  // 6. NIŠTA nije izabrano → svi oglasi
  return router.push({
    name: "oglasi-svi-oglasi-page",
    params: { page: pageParam.value }
  })
}

 
 const allCategory = async () =>{
      selectedCategory.value = null;
      selectedSubcategory.value = null;
      selectedPlace.value = null;
      category.value = false;
      subcategory.value = false;
      manu.value = true;
      filterType.value.find(x=> x.id == 1).display = false;
      router.push('/oglasi/svi-oglasi/1')
      await exitFilter()
  }

// pretraga kategorija u listi (lokalno, bez kvacica)
const categoryQuery = ref('')

const visibleCategories = computed(() => {
  const list = props.categories ?? []
  const query = normalizeText(categoryQuery.value)

  return query ? list.filter((item) => normalizeText(item.name).includes(query)) : list
})

// redovi glavnog menija: potkategorija samo kad je izabrana kategorija, mesto samo ako ima mesta
const menuRows = computed(() =>
  filterType.value.filter((type) => type.type !== 'subcategory' || selectedCategory.value)
)

const menuValue = (type) => {
  switch (type.type) {
    case 'category': return selectedCategory.value?.name
    case 'subcategory': return selectedSubcategory.value?.name
    case 'place': return selectedPlace.value?.name
    case 'buying': return selectedBuying.value
    case 'price': return selectedPrice.value
    default: return null
  }
}

const headTitle = computed(() => {
  if (manu.value) return 'Filteri'
  if (category.value) return 'Kategorije'
  if (subcategory.value) return 'Potkategorije'
  if (place.value) return 'Mesto'
  if (buying.value) return 'Kupujem / prodajem'
  if (price.value) return 'Cena / dogovor'

  return 'Filteri'
})

const backToMenu = () => {
  category.value = false
  subcategory.value = false
  place.value = false
  buying.value = false
  price.value = false
  manu.value = true
}

// izabrano kao cipovi iznad liste oglasa; klik uklanja samo taj filter
const chips = computed(() => {
  const list = []

  if (selectedCategory.value) {
    list.push({ key: 'category', label: selectedCategory.value.name, remove: () => selectCategory(selectedCategory.value) })
  }

  if (selectedSubcategory.value) {
    list.push({ key: 'subcategory', label: selectedSubcategory.value.name, remove: () => selectSubcategory(selectedSubcategory.value) })
  }

  if (selectedPlace.value) {
    list.push({ key: 'place', label: selectedPlace.value.name, remove: () => selectPlaces(selectedPlace.value) })
  }

  if (selectedBuying.value) {
    list.push({ key: 'buying', label: selectedBuying.value, remove: () => selectBuying(null) })
  }

  if (selectedPrice.value) {
    list.push({ key: 'price', label: selectedPrice.value, remove: () => selectPrice(null) })
  }

  return list
})

const modalActive = async () =>{

await addClass();

} 
const modalInActive = async () =>{

await removeClass();


} 
</script>

<style>

</style>
